/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_Q4Inputs */

const en_dr_faq_q4 = /** @type {(inputs: Dr_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens to our data?`)
};

const id_dr_faq_q4 = /** @type {(inputs: Dr_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana dengan data kami?`)
};

/**
* | output |
* | --- |
* | "What happens to our data?" |
*
* @param {Dr_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_q4 = /** @type {((inputs?: Dr_Faq_Q4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_Q4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_q4(inputs)
	return en_dr_faq_q4(inputs)
});